<div class="product-feature-optional">
  <ng-container *ngIf="coverage.type === 'activable'; else fixed">
    <mfp-switch
      [name]="product.id + '-' + coverage.id"
      [disabled]="disabled"
      [ngModel]="coverage.active"
      (ngModelChange)="onChangeActive($event)"
    ></mfp-switch>
  </ng-container>
  <ng-template #fixed>
    <div class="product-feature__icon">
      <ng-container *ngIf="coverage.type === 'not-included'; else green">
        <img
          mfpLazyImage
          lazySrc="assets/icons/cross.svg"
        />
      </ng-container>
      <ng-template #green>
        <img
          mfpLazyImage
          lazySrc="assets/icons/tick.svg"
        />
      </ng-template>
    </div>
  </ng-template>
  <div class="product-feature-optional__content">
    <p class="product-feature-optional__text">{{ coverage.description }}</p>
    <p *ngIf="coverage.percentageText" class="product-feature-optional__percentage-text">{{ '(' + coverage.percentageText + ')' }}</p>
    <div *ngIf="coverage.isAmountModifiable" class="product-feature-optional__input">
      <mfp-input
        view="agent"
        name="input"
        [type]="coverage.valueType === 'number' ? 'number' : 'text'"
        [placeholder]="placeholder"
        [required]="false"
        [readonly]="false"
        [disabled]="!coverage.active || disabled"
        [success]="false"
        [error]="coverage.active! && !disabled && getError() != '' "
        [helper]="coverage.active! && !disabled ? getError() : ''"
        [ngModel]="getValue()"
        (ngModelChange)="onChangeAmount($event)"
      ></mfp-input>
    </div>
  </div>
</div>
